import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<CtcaeCustom::BaseEditionForm @changeset={{this.changeset}} @save={{this.save}} @currentSections={{this.currentSections}} />", {
  moduleName: "core/components/ctcae-custom/post-surgery-edition-form/index.hbs"
});